// src/views/admin/Feedbacks/DeleteFeedbackModal.jsx
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from '@chakra-ui/react'

export const DeleteFeedbackModal = ({
  isOpen,
  onClose,
  onDelete,
  isLoading,
  feedbackId,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color='red.500'>Confirm Deletion</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete this feedback?
          </Text>

          <Text fontSize='sm' color='red.500' mt={2}>
            This action cannot be undone.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme='red' onClick={onDelete} isLoading={isLoading}>
            Delete
          </Button>
          <Button
            colorScheme='gray'
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
